// extracted by mini-css-extract-plugin
export default {"link":"link__Z4Uyt","logo":"logo__h3+a5","title":"title__PjZYU"};